import * as Sentry from '@sentry/react';
import { createBrowserHistory } from 'history';

// Initialize Sentry first
if (process.env.SENTRY_DSN) {
    const history = createBrowserHistory();

    Sentry.init({
        dsn: process.env.SENTRY_DSN,
        environment: `producer-news-${process.env.FRONTEND_ENV}`,
        integrations: [
            Sentry.reactRouterV5BrowserTracingIntegration({ history }),
            Sentry.replayIntegration(),
        ],
        // https://docs.sentry.io/platforms/javascript/guides/react/configuration/sampling/
        tracesSampleRate: 0.3,
        // Session Replay
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
    });
}
